(function ($) {
  var FORM_SEL = '.searchandfilter';
  var busy = false;

  // Exit early if no Search & Filter form exists on the page
  if (!$(FORM_SEL).length) {
    return;
  }

  // --- robust selection detector (matches your markup) ---
  function fieldHasSelection($field) {
    // checkboxes / radios: S&F marks aria-checked and/or --is-active
    if ($field.find('input[type=checkbox][aria-checked="true"], input[type=radio][aria-checked="true"]').length) return true;
    if ($field.find('.search-filter-input-checkbox--is-active, .search-filter-input-radio--is-active').length) return true;
    if ($field.find('input[type=checkbox]:checked, input[type=radio]:checked').length) return true;

    // selects (single + multi)
    if ($field.find('select').filter(function () {
      var v = $(this).val();
      if (Array.isArray(v)) return v.filter(Boolean).length > 0;
      if (v == null) return false;
      var s = String(v).trim().toLowerCase();
      return s !== '' && s !== 'all' && s !== '0';
    }).length) return true;

    // text-like inputs
    if ($field.find('input[type=text],input[type=search],input[type=number],input[type=date],input[type=time],input[type=email]')
             .filter(function () { return String($(this).val() || '').trim() !== ''; }).length) return true;

    return false;
  }

  // --- expand/collapse one field ---
  function setFieldExpanded($field, expand) {
    var $label = $field.find('.search-filter-label').first();
    var $groups = $field.find('.search-filter-field__input, .search-filter-input-group'); // both classes appear
    var $icon  = $label.find('.search-filter-label__toggle-icon');

    // aria-expanded only has meaning on interactive elements (button/link).
    // Prefer a nested toggle button when present; otherwise apply role=button
    // to the label so screen readers honor the state.
    var $toggleBtn = $label.find('button').first();
    if ($toggleBtn.length) {
      $toggleBtn.attr('aria-expanded', expand ? 'true' : 'false');
    } else if ($label.length) {
      if (!$label.attr('role')) $label.attr('role', 'button');
      if (!$label.attr('tabindex')) $label.attr('tabindex', '0');
      $label.attr('aria-expanded', expand ? 'true' : 'false');
    }
    $groups.toggleClass('search-filter-field__input--hidden', !expand);

    if ($icon.length) {
      $icon
        .toggleClass('search-filter-label__toggle-icon--up', expand)
        .toggleClass('search-filter-label__toggle-icon--down', !expand);
    }
  }

  function refreshAll($root) {
    if (busy) return; // never change while AJAX is building
    ($root || $(document)).find(FORM_SEL + ' .search-filter-field').each(function () {
      var $f = $(this);
      setFieldExpanded($f, fieldHasSelection($f));
    });
  }

  // --- debounce helper ---
  var refreshTimer = null;
  function scheduleRefresh($root, delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshAll($root); }, delay || 0);
  }

  // Initial pass (you start hidden in CSS)
  $(function () { scheduleRefresh($(document), 0); });

  // React on *change* (not input) for stability
  $(document).on('change', FORM_SEL + ' input, ' + FORM_SEL + ' select', function () {
    var $field = $(this).closest('.search-filter-field');
    if ($field.length) setFieldExpanded($field, fieldHasSelection($field));
  });

  // Mark busy while live search/AJAX runs
  $(document).on('sf:ajaxstart', FORM_SEL, function () { busy = true; });

  // After S&F finishes building, wait 2 RAFs then refresh (DOM fully settled)
  $(document).on('sf:ajaxfinish sf:ajaxformfinish sf:init', FORM_SEL, function () {
    busy = false;
    var $form = $(this);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scheduleRefresh($form, 0);
      });
    });
  });

  // Extra resilience: watch for DOM swaps inside the form and refresh once quiet.
  // Disconnect any prior observer on re-init so we don't accumulate.
  $(document).on('sf:init', FORM_SEL, function () {
    var form = this;
    var prev = $.data(form, 'sfMutationObserver');
    if (prev && typeof prev.disconnect === 'function') {
      try { prev.disconnect(); } catch (e) { /* ignore */ }
    }
    try {
      var mo = new MutationObserver(function () {
        if (!busy) scheduleRefresh($(form), 50);
      });
      mo.observe(form, { childList: true, subtree: true });
      $.data(form, 'sfMutationObserver', mo);
    } catch (e) {
      // MutationObserver not available – fine to skip
    }
  });
})(jQuery);

/**
 * Bricks Builder Navigation Menu - Submenu Toggle + Overflow Handling
 * Hybrid hover + click behavior:
 * - Top-level: hover opens temporarily (desktop only), click locks open
 * - Nested (sub-sub-menus): click on the toggle button opens/closes
 * - Submenus that would overflow the viewport are automatically flipped
 */
(function ($) {
  $(document).ready(function () {
    var lockedMenus = [];

    var ROOT_SELECTOR = '#brxe-bcriqb'; // your wrapper id
    var $root = $(ROOT_SELECTOR);
    if (!$root.length) return;

    // Root ULs to support both desktop + mobile menus
    var $menus = $root.find('ul.bricks-nav-menu, ul.bricks-mobile-menu');

    function ensureId($li) {
      var id = $li.attr('id');
      if (!id) {
        id = 'brx-top-' + Math.random().toString(36).slice(2);
        $li.attr('id', id);
      }
      return id;
    }

    function isLocked(menuId) {
      return lockedMenus.indexOf(menuId) !== -1;
    }

    function lock(menuId) {
      if (!isLocked(menuId)) lockedMenus.push(menuId);
    }

    function unlock(menuId) {
      var idx = lockedMenus.indexOf(menuId);
      if (idx !== -1) lockedMenus.splice(idx, 1);
    }

    // Reset any flip-positioning we previously applied to a submenu.
    function resetSubmenuPosition($submenu) {
      $submenu.removeClass('brx-submenu-flipped brx-submenu-flipped-nested');
      $submenu.css({ left: '', right: '' });
    }

    // If a submenu would extend past the viewport's right edge, flip it.
    // - Top-level submenu: anchor its right edge to the parent <li>'s right edge.
    // - Nested submenu: open to the LEFT of the parent submenu instead of the right.
    // Only applies to the desktop nav; the mobile menu stacks vertically.
    // Call this BEFORE slideDown so the element is positioned correctly from
    // the start of the animation. If the element is currently hidden, we
    // temporarily render it invisibly to measure, then restore.
    function adjustSubmenuPosition($submenu) {
      var $ul = $submenu.closest('ul.bricks-nav-menu, ul.bricks-mobile-menu');
      if (!$ul.length || $ul.hasClass('bricks-mobile-menu')) return;
      if (window.innerWidth <= 991) return;

      var el = $submenu[0];
      if (!el) return;

      // Reset any prior flip so we measure the natural position.
      resetSubmenuPosition($submenu);

      // If the submenu is currently hidden (display:none), force it visible
      // off-screen to measure, then restore. We use visibility:hidden so the
      // user never sees a flash.
      var inlineStyle = el.style.cssText;
      var computedDisplay = window.getComputedStyle(el).display;
      var needsRestore = false;
      if (computedDisplay === 'none') {
        el.style.visibility = 'hidden';
        el.style.display = 'block';
        needsRestore = true;
      }

      var rect = el.getBoundingClientRect();
      var vw = window.innerWidth;
      var margin = 8;
      var overflows = rect.right > vw - margin;

      // Restore original inline style before applying flip styles, so we
      // don't leave display/visibility overrides behind.
      if (needsRestore) {
        el.style.cssText = inlineStyle;
      }

      if (overflows) {
        var isNested = $submenu.parent().closest('ul.sub-menu').length > 0;
        if (isNested) {
          // Open to the LEFT of the parent submenu
          $submenu
            .addClass('brx-submenu-flipped brx-submenu-flipped-nested')
            .css({ left: 'auto', right: '100%' });
        } else {
          // Align right edge with the parent <li>'s right edge
          $submenu
            .addClass('brx-submenu-flipped')
            .css({ left: 'auto', right: '0' });
        }
      }
    }

    // Close any nested submenus that are currently open inside $submenu.
    // Recurses so multi-level nesting fully resets (sub > sub-sub > sub-sub-sub).
    function closeNestedSubmenus($submenu) {
      $submenu.find('li.bricks-menu-item-open').each(function () {
        var $nested = $(this);
        var $nestedSub = $nested.children('ul.sub-menu');
        // Recurse first so deeper levels are cleared before we hide the parent.
        if ($nestedSub.length) closeNestedSubmenus($nestedSub);
        $nested.removeClass('bricks-menu-item-open');
        if ($nestedSub.length) {
          $nestedSub.stop(true, true).hide();
          resetSubmenuPosition($nestedSub);
        }
        var $nestedBtn = $nested.find('> .brx-submenu-toggle > button');
        $nestedBtn.attr('aria-expanded', 'false');
        $nestedBtn.find('.menu-item-icon').removeClass('rotated');
      });
    }

    // OPEN/CLOSE only direct child submenu of that TOP li
    function openSubmenu($menuItem, isLocking) {
      var $submenu = $menuItem.children('ul.sub-menu');
      var $button = $menuItem.find('> .brx-submenu-toggle > button');

      $menuItem.addClass('bricks-menu-item-open');
      if (isLocking) {
        $menuItem.addClass('locked-open');
        $button.find('.menu-item-icon').addClass('rotated');
      }

      $submenu.stop(true, true).slideDown(250);
      $button.attr('aria-expanded', 'true');

      adjustSubmenuPosition($submenu);
    }

    function closeSubmenu($menuItem, force) {
      var $submenu = $menuItem.children('ul.sub-menu');
      var $button = $menuItem.find('> .brx-submenu-toggle > button');
      var menuId = ensureId($menuItem);

      if (!force && isLocked(menuId)) return;

      $menuItem.removeClass('bricks-menu-item-open locked-open');
      // Close any open nested submenus inside, then collapse this one.
      closeNestedSubmenus($submenu);
      $submenu.stop(true, true).slideUp(250, function () {
        resetSubmenuPosition($submenu);
      });
      $button.attr('aria-expanded', 'false');
      $button.find('.menu-item-icon').removeClass('rotated');

      unlock(menuId);
    }

    // Toggle a NESTED (sub-sub-menu and deeper) submenu via button click.
    function toggleNestedSubmenu($menuItem) {
      var $submenu = $menuItem.children('ul.sub-menu');
      var $button = $menuItem.find('> .brx-submenu-toggle > button');
      var isOpen = $menuItem.hasClass('bricks-menu-item-open');

      if (isOpen) {
        $menuItem.removeClass('bricks-menu-item-open');
        closeNestedSubmenus($submenu);
        $submenu.stop(true, true).slideUp(250, function () {
          resetSubmenuPosition($submenu);
        });
        $button.attr('aria-expanded', 'false');
        $button.find('.menu-item-icon').removeClass('rotated');
      } else {
        // Close sibling nested submenus at the same level
        $menuItem.siblings('li.menu-item-has-children.bricks-menu-item-open').each(function () {
          var $sib = $(this);
          $sib.removeClass('bricks-menu-item-open');
          var $sibSub = $sib.children('ul.sub-menu');
          closeNestedSubmenus($sibSub);
          $sibSub.stop(true, true).slideUp(250, function () {
            resetSubmenuPosition($sibSub);
          });
          var $sibBtn = $sib.find('> .brx-submenu-toggle > button');
          $sibBtn.attr('aria-expanded', 'false');
          $sibBtn.find('.menu-item-icon').removeClass('rotated');
        });

        $menuItem.addClass('bricks-menu-item-open');
        $submenu.stop(true, true).slideDown(250);
        $button.attr('aria-expanded', 'true');
        $button.find('.menu-item-icon').addClass('rotated');

        adjustSubmenuPosition($submenu);
      }
    }

    // TOP-LEVEL items only: li.menu-item-has-children that are direct children of the root UL
    function getTopItems($ul) {
      return $ul.children('li.menu-item-has-children');
    }

    // Collected per-UL rebind hooks, used by the single shared resize listener.
    var menuRebinders = [];

    // Bind for each menu UL separately (desktop + mobile)
    $menus.each(function () {
      var $ul = $(this);
      var $topItems = getTopItems($ul);

      // Click toggle for top-level buttons
      $topItems.find('> .brx-submenu-toggle > button').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $button = $(this);
        var $menuItem = $button.closest('li.menu-item-has-children');

        // Safety: ensure it's truly top-level in THIS ul
        if ($menuItem.parent()[0] !== $ul[0]) return;

        var menuId = ensureId($menuItem);

        if (isLocked(menuId)) {
          closeSubmenu($menuItem, true);
        } else {
          // close other locked top-level items in this UL
          $topItems.each(function () {
            var $other = $(this);
            var otherId = ensureId($other);
            if (otherId !== menuId && isLocked(otherId)) {
              closeSubmenu($other, true);
            }
          });

          lock(menuId);
          openSubmenu($menuItem, true);
        }
      });

      // Click toggle for NESTED submenu buttons (anything under .sub-menu)
      $ul.on('click', '.sub-menu .brx-submenu-toggle > button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $button = $(this);
        var $menuItem = $button.closest('li.menu-item-has-children');

        // Skip if this is actually a top-level item (handled above)
        if ($menuItem.parent()[0] === $ul[0]) return;

        toggleNestedSubmenu($menuItem);
      });

      // Desktop hover ONLY for top-level items (ignore nested)
      function bindHover() {
        $topItems.off('.topHover');
        if ($(window).width() > 991 && $ul.hasClass('bricks-nav-menu')) {
          $topItems.on('mouseenter.topHover', function () {
            var $menuItem = $(this);
            var menuId = ensureId($menuItem);
            if (!isLocked(menuId)) openSubmenu($menuItem, false);
          });

          $topItems.on('mouseleave.topHover', function () {
            closeSubmenu($(this), false);
          });
        }
      }

      // Desktop hover for nested items: CSS handles show/hide, but we still
      // need to re-check overflow positioning when a nested submenu opens.
      function bindNestedHover() {
        var $nestedItems = $ul.find('.sub-menu li.menu-item-has-children');
        $nestedItems.off('.nestedHover');
        if ($(window).width() > 991 && $ul.hasClass('bricks-nav-menu')) {
          $nestedItems.on('mouseenter.nestedHover', function () {
            var $nestedSub = $(this).children('ul.sub-menu');
            if ($nestedSub.length) adjustSubmenuPosition($nestedSub);
          });
          $nestedItems.on('mouseleave.nestedHover', function () {
            var $nestedSub = $(this).children('ul.sub-menu');
            // Only reset if it's not click-locked open
            if ($nestedSub.length && !$(this).hasClass('bricks-menu-item-open')) {
              resetSubmenuPosition($nestedSub);
            }
          });
        }
      }

      bindHover();
      bindNestedHover();

      // Expose the rebind callbacks so the single shared resize listener
      // below can iterate every menu UL without re-binding its own listener.
      menuRebinders.push({
        ul: $ul,
        topItems: $topItems,
        bindHover: bindHover,
        bindNestedHover: bindNestedHover,
      });
    });

    // Single shared resize listener (was previously bound once per menu UL).
    var resizeTimer;
    $(window).on('resize.brxNav', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var onMobile = $(window).width() <= 991;
        if (onMobile) {
          // Close all top-level items and clear lock state on mobile breakpoint.
          menuRebinders.forEach(function (r) {
            r.topItems.each(function () { closeSubmenu($(this), true); });
          });
          lockedMenus = [];
        }
        menuRebinders.forEach(function (r) {
          r.bindHover();
          r.bindNestedHover();
        });
      }, 250);
    });

    // Clicking outside the whole nav wrapper closes unlocked TOP-LEVEL only
    $(document).on('click', function (e) {
      if (!$(e.target).closest($root).length) {
        $menus.each(function () {
          var $ul = $(this);
          getTopItems($ul).each(function () {
            var $menuItem = $(this);
            var menuId = ensureId($menuItem);
            if (!isLocked(menuId)) closeSubmenu($menuItem, false);
          });
        });
      }
    });

    // Esc closes ALL top-level (locked or not)
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        $menus.each(function () {
          getTopItems($(this)).each(function () {
            closeSubmenu($(this), true);
          });
        });
        lockedMenus = [];
      }
    });
  });
})(jQuery);
